import React from 'react'

export const Presenter = ({ children }) => <>{children}</>
